import { useEffect } from "preact/hooks"
import { ICtaV2 } from "../interfaces/event-actions";
import { useActionEmitter } from "./action-emitter";
import { useProgramActionHandler } from "./program";
import { useRewardActionHandler } from "./reward";
import { useRouterActionHandler } from "./router";
import { useSessionActionHandler } from "./session";
import { useUser, useUserActionHandler } from "./user";

export const useExternalEventListener = () => {
  const [onRouterAction] = useRouterActionHandler();
  const [rewardStatus, onRewardAction] = useRewardActionHandler();
  const [programStatus, onProgramAction] = useProgramActionHandler();
  const [userStatus, onUserAction] = useUserActionHandler();
  const [onSessionAction] = useSessionActionHandler();
  const [status, emit] = useActionEmitter([onRouterAction, onRewardAction, onProgramAction, onUserAction, onSessionAction], {});

  useEffect(() => {
    if(!window || !document.addEventListener) return;

    const listener = (event: MessageEvent<ICtaV2>) => {
      console.log("--EVENT RECIVED--");
      console.log(event);
      if(!event.data) return;
      const cta = event.data;
      if(cta.target !== "STORE_V2") return;
      emit(cta);
    }
    window.addEventListener("message", listener);

    if(window && window.parent !== window) {
      window.parent.postMessage({isLoaded: true}, "*")
    }
    return () => window.removeEventListener("message", listener);
  }, []);
}